

const updateMatchup = (state = {}, action = {}) => {
    const {
        type = null,
        datasource,
        data = {}
    } = action;

    if (type === 'dataEngine_update_response' ) {

        if (datasource === 'gumbo') {
            const {
                gamePk
            } = data;

            return {...state, ...{gumboGamePk: gamePk}};
        }

        if (datasource === 'teamvsPitcher') {

            const newData = {
                isDataLoaded: data?.isDataLoaded,
                gamePk: action?.params?.gamePk
            }
            return {...state, ...data?.data, ...newData };
        }


    }
    return state;
};

export default updateMatchup;
